import React, { createContext, useContext, useState, useEffect } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState(() => {
    const items = sessionStorage.getItem("breadcrumbs");
    return items ? JSON.parse(items) : [];
  });

  const [breadcrumbHistory, setBreadcrumbHistory] = useState(() => {
    const stored = sessionStorage.getItem("breadcrumbHistory");
    return stored ? JSON.parse(stored) : [];
  });

  const addBreadcrumb = (label, path, isNew = false) => {
    if (path === "/") {
      setBreadcrumbs([]);
      sessionStorage.removeItem("breadcrumbs");
      return;
    }
    const newBreadcrumbs = isNew
      ? [
          { label: "Home", path: "/" },
          { label, path },
        ]
      : breadcrumbs.some((b) => b.path === path)
      ? breadcrumbs
      : [...breadcrumbs, { label, path }];

    setBreadcrumbs(newBreadcrumbs);
    sessionStorage.setItem("breadcrumbs", JSON.stringify(newBreadcrumbs));
    setBreadcrumbHistory((prev) => {
      const exists = prev.find((b) => b.path === path);
      const updated = exists ? prev : [...prev, { label, path }];
      sessionStorage.setItem("breadcrumbHistory", JSON.stringify(updated));
      return updated;
    });
  };

  const addMultiBreadCrumb = (paths) => {
    setBreadcrumbs(paths);
    setBreadcrumbHistory((prev) => {
      const updated = [...prev];
      paths.forEach((item) => {
        if (!updated.find((b) => b.path === item.path)) {
          updated.push(item);
        }
      });
      sessionStorage.setItem("breadcrumbHistory", JSON.stringify(updated));
      return updated;
    });
    sessionStorage.setItem("breadcrumbs", JSON.stringify(paths));
  };

  const removeBreadcrumb = (index) => {
    const updated = breadcrumbs.slice(0, index);
    setBreadcrumbs(updated);
    sessionStorage.setItem("breadcrumbs", JSON.stringify(updated));
  };

  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname;

      if (currentPath === "/") {
        setBreadcrumbs([]);
        sessionStorage.removeItem("breadcrumbs");
        return;
      }

      const index = breadcrumbHistory.findIndex((b) => b.path === currentPath);

      if (index !== -1) {
        const sliced = breadcrumbHistory.slice(0, index + 1);
        const hasHome = sliced.find((b) => b.path === "/");
        const newTrail = hasHome
          ? sliced
          : [{ label: "Home", path: "/" }, ...sliced];
        setBreadcrumbs(newTrail);
        sessionStorage.setItem("breadcrumbs", JSON.stringify(newTrail));
      } else {
        setBreadcrumbs([]);
        sessionStorage.setItem("breadcrumbs", JSON.stringify([]));
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [breadcrumbHistory]);

  return (
    <BreadcrumbContext.Provider
      value={{
        breadcrumbs,
        addBreadcrumb,
        removeBreadcrumb,
        addMultiBreadCrumb,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);
